module.exports = __webpack_public_path__ + "assets/e71235f11466e304c81bad3b487ac764.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/boom.mp3
 ** module id = 221
 ** module chunks = 0
 **/